import React, {Component} from "react";
import NavBar from "../NavBar";


class VerificationSuccessPage extends Component {
    render(){
        return(
            <div>
                <NavBar />
                <h2>
                    You have verified your account. Log in below to start your application.
                </h2> 
            </div>
        )
    }

}

export default VerificationSuccessPage;